import { CrossSellingPointer } from "../../others/crossSellingPointer.js";
import { RCL } from "../names.js";
const crossRclAssignGutenberg = ()=>CrossSellingPointer.waitForVisibleElement("body.wp-admin .editor-post-taxonomies__hierarchical-terms-list:visible", RCL, "assign", "bottom");
export { crossRclAssignGutenberg };
